import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductAggregatedFilter = _resolveComponent("ProductAggregatedFilter")!
  const _component_ProductAggregatedBaseInfo = _resolveComponent("ProductAggregatedBaseInfo")!
  const _component_ProductAggregatedTable = _resolveComponent("ProductAggregatedTable")!
  const _component_AggregatedPageWrapper = _resolveComponent("AggregatedPageWrapper")!

  return (_ctx.isAccessAllowed)
    ? (_openBlock(), _createBlock(_component_AggregatedPageWrapper, {
        key: 0,
        title: "Агрегированные данные (Экспорт, импорт) по товарам",
        exportConfig: _ctx.getExportConfig
      }, {
        filter: _withCtx(() => [
          _createVNode(_component_ProductAggregatedFilter, {
            onSearchFilter: _ctx.searchFilter,
            onUpdateFilter: _ctx.updateFilter,
            defaultFilter: _ctx.defaultFilter,
            readonlyPermissionCode: _ctx.getPermissions.build
          }, null, 8, ["onSearchFilter", "onUpdateFilter", "defaultFilter", "readonlyPermissionCode"])
        ]),
        "base-info": _withCtx(() => [
          _createVNode(_component_ProductAggregatedBaseInfo, { filter: _ctx.filter }, null, 8, ["filter"])
        ]),
        table: _withCtx(() => [
          _createVNode(_component_ProductAggregatedTable, { filter: _ctx.filter }, null, 8, ["filter"])
        ]),
        _: 1
      }, 8, ["exportConfig"]))
    : _createCommentVNode("", true)
}